import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types';
import { type AdminHubExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export { Editions } from './types';
export type { AdminHubExtensionsOptions } from './types';

export const adminHubExtensionsWhitelist: string[] = [
	'edition',
	'migrationSourceUuid',
	'grantAccessTo',
];

export const createAdminHubExtensions: (options: AdminHubExtensionsOptions) => CrossFlowExtensions =
	createProductExtensions<AdminHubExtensionsOptions>(adminHubExtensionsWhitelist);
